import { StageQuestionsService } from 'app/stages/stage-questions.service';
import { Observable } from 'rxjs/Observable';
import { Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { SecurityService } from '../../security.service';
import { SelectListItemModel } from 'app/shared/models/select-list-item.model';

@Component({
  selector: 'online-app-user-profile',
  templateUrl: './user-profile.component.html',
  styleUrls: ['./user-profile.component.scss']
})
export class UserProfileComponent implements OnInit {

  constructor(
    private securityService:SecurityService, 
    private router:Router, 
    private stagesSer:StageQuestionsService) {
      this.stagesSer.getStagesLookup().subscribe(stages=>{   
        this.stagesProgressPercentages=Math.round(this.securityService.currentUserInfo.currentStageNumber/stages.length*100);
      });
   }

  protected get login():string{
    return this.securityService.currentUserInfo.email;
  }

  protected get program():string{
    return this.securityService.currentUserInfo.programTitle;
  }

  private get stage():Observable<SelectListItemModel>{
    if(!this.securityService.currentUserInfo.stageLuid){
      this.securityService.toastr.error('Invalid data, cannot find user current stage. Please contact server admin')
      return null;
    }
    return this.stagesSer.getStagesLookup().map(items=>{
      return items.find(i=>i?i.value==this.securityService.currentUserInfo.stageLuid.toString():null)
    });
  }

  protected get stageName():Observable<string>{
    return this.stage.map(i=>{return i?i.name:'REVIEW AND SUBMIT'});
  }

  stagesProgressPercentages:number=0;

  ngOnInit() {

  }

  protected back(){
    this.router.navigate(["/stages"])
  }

}



// WEBPACK FOOTER //
// ./src/app/security/security/user-profile/user-profile.component.ts